import type {
  ServiceGetByIdResponse,
  ServiceMutationOptionType,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { CariPetaniDataType } from './types'
import type { FilterCariPetaniValues } from './validation'

const CARI_PETANI_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['cari-petani', key] as const

const getById = (
  params?: FilterCariPetaniValues
): ServiceQueryOptionType<ServiceGetByIdResponse<CariPetaniDataType>> => ({
  queryKey: CARI_PETANI_QUERY_KEY(params),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetByIdResponse<CariPetaniDataType>
      >(`/kelembagaan/petani/cari`, {
        params
      })
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const searchNik = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<CariPetaniDataType>,
  { nik: string; gapoktan_id?: string }
> => ({
  mutationKey: CARI_PETANI_QUERY_KEY('search-nik'),
  mutationFn: async (data: { nik: string; gapoktan_id?: string }) => {
    try {
      const response = await api.post<
        ServiceGetByIdResponse<CariPetaniDataType>
      >(`/kelembagaan/petani/cari`, {
        ...data
      })
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const searchNikWithLahan = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<CariPetaniDataType>,
  { nik: string }
> => ({
  mutationKey: CARI_PETANI_QUERY_KEY('search-nik-with-lahan'),
  mutationFn: async (data: { nik: string }) => {
    try {
      const response = await api.post<
        ServiceGetByIdResponse<CariPetaniDataType>
      >(
        `/kelembagaan/petani/cari-lahan`,
        {
          ...data
        },
        { timeout: 15_000 }
      )
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const cariPetani = {
  //   getAll,
  getById,
  searchNik,
  searchNikWithLahan
}
